import { render, staticRenderFns } from "./BaseContents.vue?vue&type=template&id=1a704e74"
import script from "./BaseContents.vue?vue&type=script&lang=js"
export * from "./BaseContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports